import api from './api';
import { Piso, CreatePisoForm, UpdatePisoForm, ApiResponse } from '../types';

export const pisoService = {
  async getPisos(): Promise<ApiResponse<Piso[]>> {
    try {
      const response = await api.get('/Pisos');
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al cargar los pisos',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async getPisosActivos(): Promise<ApiResponse<Piso[]>> {
    try {
      const response = await api.get('/Pisos/activos');
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al cargar los pisos activos',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async createPiso(piso: CreatePisoForm): Promise<ApiResponse<Piso>> {
    try {
      // Validaciones del lado del cliente
      if (!piso.nombre?.trim()) {
        return { 
          success: false, 
          message: 'El nombre del piso es requerido',
          errors: ['El nombre del piso es requerido']
        };
      }

      if (piso.nombre.length > 200) {
        return { 
          success: false, 
          message: 'El nombre del piso no puede exceder 200 caracteres',
          errors: ['El nombre del piso no puede exceder 200 caracteres']
        };
      }

      if (piso.descripcion && piso.descripcion.length > 500) {
        return { 
          success: false, 
          message: 'La descripción no puede exceder 500 caracteres',
          errors: ['La descripción no puede exceder 500 caracteres']
        };
      }

      const response = await api.post('/Pisos', piso);
      return { success: true, data: response.data };
    } catch (error: any) {
      // Manejar específicamente el error de límite de plan
      if (error.response?.data?.message?.includes('máximo de pisos')) {
        return { 
          success: false, 
          message: 'Has alcanzado el máximo de pisos de tu plan. Considera subir de plan para crear más pisos.',
          errors: ['Límite de plan alcanzado']
        };
      }
      
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al crear el piso',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async updatePiso(id: number, piso: UpdatePisoForm): Promise<ApiResponse<Piso>> {
    try {
      // Validaciones del lado del cliente
      if (!piso.nombre?.trim()) {
        return { 
          success: false, 
          message: 'El nombre del piso es requerido',
          errors: ['El nombre del piso es requerido']
        };
      }

      if (piso.nombre.length > 200) {
        return { 
          success: false, 
          message: 'El nombre del piso no puede exceder 200 caracteres',
          errors: ['El nombre del piso no puede exceder 200 caracteres']
        };
      }

      if (piso.descripcion && piso.descripcion.length > 500) {
        return { 
          success: false, 
          message: 'La descripción no puede exceder 500 caracteres',
          errors: ['La descripción no puede exceder 500 caracteres']
        };
      }

      const response = await api.put(`/Pisos/${id}`, piso);
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al actualizar el piso',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async deletePiso(id: number): Promise<ApiResponse<void>> {
    try {
      await api.delete(`/Pisos/${id}`);
      return { success: true };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al eliminar el piso',
        errors: error.response?.data?.errors || []
      };
    }
  },
}; 